module.exports = __webpack_public_path__ + "static/media/fire_in_the_hole.nolimitcity.a8fb3c90.jpeg";